// extracted by mini-css-extract-plugin
module.exports = {"CandidateEditorPreview":"z2WkxMSw","viewCandidate":"_1gkBoa2r","titleBlock":"f3p0Ei0d","middleBlock":"_33JOeIn3","mainBlock":"_32DEIETO","scrollDiv":"qJ2TIT-1","dataVisualsRow":"ErSAtmks","dataVisualFirstBlock":"_2asszkOb","dataVisualSecondBlock":"_2M4Oab1f","visualsSubtitle":"_3VKnf09w","emptyDataVisual":"_38R5SROi","dataVisualsMostRecent":"Ow04gVRq"};
    if(module.hot) {
      // 1746735766163
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  